import { useState } from 'react';

import { cn } from '@nesso/ui/lib/utils';

import type { TreatmentApproach } from '@/entities/session';
import type { SessionNoteSettings } from '@/entities/session-note';
import { getTreatmentApproachLabels } from '@/entities/treatment-approach';
import { EditTreatmentApproaches } from '@/features/session-note/edit-treatment-approaches';

interface Props {
    sessionId: string;
    selectedApproaches: TreatmentApproach[];
    settings: SessionNoteSettings;
}

export function SoapSessionNoteTreatmentApproaches({
    sessionId,
    selectedApproaches,
    settings,
}: Props) {
    const [open, setOpen] = useState(false);
    const labels = getTreatmentApproachLabels(selectedApproaches);

    return (
        <div className="flex items-center">
            <span className="sm:text-xl">{labels.join(', ')}</span>
            <EditTreatmentApproaches
                sessionId={sessionId}
                selectedApproaches={selectedApproaches}
                type="SOAP"
                settings={settings}
                popoverContentProps={{
                    side: 'bottom',
                    align: 'start',
                    className: 'block min-w-[375px] p-4 gap-4',
                }}
                buttonClassName={cn('h-6 w-6 ml-2', open && 'bg-accent/50')}
                onOpenChange={setOpen}
                open={open}
            />
        </div>
    );
}
